export enum BoardMode {
    DEFAULT_PLANNING = 0,
    ASSIGN_EQUIPMENT = 1,
}
